// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DisplayTrendsData.css */

/* Wrapper for the entire component */
.trends-data-wrapper {
    padding: 20px;
  }
  
  /* Flex container for the header section */
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  /* Flex container for button group */
  .button-group {
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 10px;
  }
  
  /* Table container with overflow */
  .table-container {
    overflow-x: auto;
    border: 1px solid #ccc;
    max-height: 550px;
  }
  
  /* General table styles */
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    padding: 8px;
    text-align: center;
    border: 1px solid black;
  }
  
  th {
    background-color: var(--primary-color);
    color: #fff;
  }
  
  /* Styling for trend arrows */
  .trend-arrow {
    font-size: 38px;
  }
  
  .green-arrow {
    color: green;
  }
  
  .red-arrow {
    color: red;
  }
  
  .neutral-arrow {
    font-size: 38px;
  }
  
  /* Button styles */
  .button-show {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
  }
  
 
  

  /* Show less / show more button styles */
  .show-more-btn {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
  }
  
  .show-more-btn:hover {
    background-color: var(--primary-color);
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/trends-data/trends-data.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,qCAAqC;AACrC;IACI,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA,kCAAkC;EAClC;IACE,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;IACtC,WAAW;EACb;;EAEA,6BAA6B;EAC7B;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;;;;EAKA,wCAAwC;EACxC;IACE,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sCAAsC;EACxC","sourcesContent":["/* DisplayTrendsData.css */\n\n/* Wrapper for the entire component */\n.trends-data-wrapper {\n    padding: 20px;\n  }\n  \n  /* Flex container for the header section */\n  .header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  /* Flex container for button group */\n  .button-group {\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    padding: 10px;\n  }\n  \n  /* Table container with overflow */\n  .table-container {\n    overflow-x: auto;\n    border: 1px solid #ccc;\n    max-height: 550px;\n  }\n  \n  /* General table styles */\n  table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  th, td {\n    padding: 8px;\n    text-align: center;\n    border: 1px solid black;\n  }\n  \n  th {\n    background-color: var(--primary-color);\n    color: #fff;\n  }\n  \n  /* Styling for trend arrows */\n  .trend-arrow {\n    font-size: 38px;\n  }\n  \n  .green-arrow {\n    color: green;\n  }\n  \n  .red-arrow {\n    color: red;\n  }\n  \n  .neutral-arrow {\n    font-size: 38px;\n  }\n  \n  /* Button styles */\n  .button-show {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    border: none;\n  }\n  \n \n  \n\n  /* Show less / show more button styles */\n  .show-more-btn {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    border: none;\n  }\n  \n  .show-more-btn:hover {\n    background-color: var(--primary-color);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
